module.exports = __webpack_public_path__ + "static/media/0_2019_04_25.bab91a33.jpg";